import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { getScrollTriggerRefreshPriority } from './scroll-trigger-priority'

gsap.registerPlugin(ScrollTrigger, SplitText)

export function initHighlightText(root = document) {
    let splitHeadingTargets = root.querySelectorAll('[data-highlight-text]')
    splitHeadingTargets.forEach((heading) => {
        if (heading.dataset.highlightTextInitialized === 'true') return
        heading.dataset.highlightTextInitialized = 'true'

        const scrollStart =
            heading.getAttribute('data-highlight-scroll-start') || 'top 90%'
        const scrollEnd =
            heading.getAttribute('data-highlight-scroll-end') || 'center 40%'
        const fadedValue = Number(
            heading.getAttribute('data-highlight-fade') || 0.2
        ) // Opacity of letter
        const staggerValue = Number(
            heading.getAttribute('data-highlight-stagger') || 0.1
        ) // Smoother reveal

        new SplitText(heading, {
            type: 'words, chars',
            autoSplit: true,
            onSplit(self) {
                let ctx = gsap.context(() => {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            refreshPriority:
                                getScrollTriggerRefreshPriority(heading),
                            scrub: true,
                            trigger: heading,
                            start: scrollStart,
                            end: scrollEnd,
                            markers: false
                        }
                    })
                    tl.fromTo(
                        self.chars,
                        {
                            autoAlpha: fadedValue
                        },
                        {
                            autoAlpha: 1,
                            stagger: staggerValue,
                            ease: 'linear'
                        }
                    )
                })
                return ctx // return our animations so GSAP can clean them up when onSplit fires
            }
        })
    })
}
